module.exports = __webpack_public_path__ + "media/Loops 110 Bass.57712425.wav";